import {IStore} from '@/store/types';
import {IModuleState} from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
    dpsPage: {data: [], pageNum: 0, pageSize: 0, total: 0, loading: false},
    dpscPage: {data: [], pageNum: 0, pageSize: 0, total: 0, loading: false},
    list: {data: [], pageNum: 0, pageSize: 0, total: 0, loading: false},
    listDpsc: {data: [], pageNum: 0, pageSize: 0, total: 0, loading: false},
    restoreList: {data: [], pageNum: 0, pageSize: 0, total: 0, loading: false},
    logs: {data: [], pageNum: 0, pageSize: 0, total: 0, loading: false},
    detail: {data: null, loading: false},
    envLight: {data: null, loading: false},
    orgs: {data: [], loading: false},
    allModels: {data: [], pageNum: 0, pageSize: 0, total: 0, loading: false},
    allMaterials: {data: [], pageNum: 0, pageSize: 0, total: 0, loading: false},
    models: {data: [], loading: false},
    materials: {data: [], loading: false},
    libFurs: {data: [], loading: false},
    filters: {data: [], loading: false},
    statusTypes: {data: [], raw: [], loading: false},
    shelfCheck: {data: null, params: null, visible: false, loading: false},
    upgradeCheck: {data: null, params: null, visible: false, loading: false},
    dialog: {type: '', visible: false, loading: false},
    confirm: {title: '', content: '', name: '', visible: false, loading: false},
    searchParams: null,
    search: null,
    dpscSearch: null,
    loading: false,
};

export default {namespaced: true, state: initialState, actions, mutations} as IStore<IModuleState>;
